var map = {
	".": [
		67672,
		9
	],
	"./": [
		67672,
		9
	],
	"./App": [
		73465,
		9
	],
	"./App.css": [
		93508,
		9
	],
	"./App.test": [
		33517,
		9,
		930,
		926,
		517
	],
	"./App.test.tsx": [
		33517,
		9,
		930,
		926,
		517
	],
	"./App.tsx": [
		73465,
		9
	],
	"./CombinedImage": [
		59261,
		9
	],
	"./CombinedImage.tsx": [
		59261,
		9
	],
	"./components/EmojiButton": [
		85914,
		9
	],
	"./components/EmojiButton.tsx": [
		85914,
		9
	],
	"./emojiConfig": [
		55374,
		3
	],
	"./emojiConfig.json": [
		55374,
		3
	],
	"./images/image-1.jpeg": [
		38742,
		1,
		742
	],
	"./images/image-2.jpeg": [
		33369,
		1,
		369
	],
	"./images/image-3.jpeg": [
		11613,
		1,
		613
	],
	"./images/image-4.jpeg": [
		66428,
		1,
		428
	],
	"./index": [
		67672,
		9
	],
	"./index.css": [
		51174,
		9
	],
	"./index.tsx": [
		67672,
		9
	],
	"./logo.svg": [
		31100,
		1,
		100
	],
	"./react-app-env.d": [
		44398,
		7,
		398
	],
	"./react-app-env.d.ts": [
		44398,
		7,
		398
	],
	"./reportWebVitals": [
		58983,
		9
	],
	"./reportWebVitals.ts": [
		58983,
		9
	],
	"./setupTests": [
		22887,
		9,
		930,
		89,
		887
	],
	"./setupTests.ts": [
		22887,
		9,
		930,
		89,
		887
	],
	"./svgFiles/emoji/baseball_color.svg": [
		39780,
		1,
		780
	],
	"./svgFiles/emoji/dolphin_color.svg": [
		45010,
		1,
		10
	],
	"./svgFiles/emoji/evergreen_tree_color.svg": [
		18610,
		1,
		610
	],
	"./svgFiles/emoji/eyes_color.svg": [
		18316,
		1,
		316
	],
	"./svgFiles/emoji/face_vomiting_color.svg": [
		38278,
		1,
		278
	],
	"./svgFiles/emoji/face_with_raised_eyebrow_color.svg": [
		11683,
		1,
		683
	],
	"./svgFiles/emoji/file_folder_color.svg": [
		74521,
		1,
		521
	],
	"./svgFiles/emoji/fire_color.svg": [
		51306,
		1,
		306
	],
	"./svgFiles/emoji/smiling_face_with_halo_color.svg": [
		6706,
		1,
		706
	],
	"./svgFiles/emoji/spoon_color.svg": [
		48329,
		1,
		329
	],
	"./svgFiles/emoji/sunglasses_color.svg": [
		94989,
		1,
		989
	],
	"./svgFiles/emoji/sweat_droplets_color.svg": [
		96071,
		1,
		71
	],
	"./svgFiles/parts/dolphin.svg": [
		16404,
		1,
		404
	],
	"./svgFiles/parts/face/face.svg": [
		63679,
		1,
		679
	],
	"./svgFiles/parts/face/halo.svg": [
		85337,
		1,
		337
	],
	"./svgFiles/parts/face/halo_with_face.svg": [
		97769,
		1,
		769
	],
	"./svgFiles/parts/face/raised_eyebrow.svg": [
		86588,
		1,
		588
	],
	"./svgFiles/parts/face/vomiting.svg": [
		55332,
		1,
		332
	],
	"./types/emojiConfigFile": [
		1730,
		9,
		730
	],
	"./types/emojiConfigFile.ts": [
		1730,
		9,
		730
	],
	"./types/emojiMetadata": [
		70823,
		9
	],
	"./types/emojiMetadata.ts": [
		70823,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20075;
module.exports = webpackAsyncContext;